import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../redux/default/reducer";
import ViewModeSwitcher from "../components/view_mode_switcher";
import { selectDefaultReducer } from "../redux/default/selectors";

const ViewModeSwitcherContainer = () => {
  const dispatch = useDispatch();

  const { viewMode } = useSelector(selectDefaultReducer);
  const onViewModeChange = (viewMode) => dispatch(Action.viewModeChanged(viewMode));

  return (
    <ViewModeSwitcher 
      viewMode={viewMode} 
      onViewModeChange={onViewModeChange} 
    />
  )
};

export default ViewModeSwitcherContainer;